module.exports = __webpack_public_path__ + "static/img/Testimonials-bg.463f6b53.jpg";